import { render, staticRenderFns } from "./AttachLectureToCourse.vue?vue&type=template&id=93bdd86c&"
import script from "./AttachLectureToCourse.vue?vue&type=script&lang=ts&"
export * from "./AttachLectureToCourse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports